module.exports = __webpack_public_path__ + "media/icons/check-black-e2e37c66.svg";